import { defineMessages } from 'react-intl';

export const messages: {
	modalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	startBlankDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewMoreTemplates: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeModal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	buttonUseTemplate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeModalLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	startBlankDocLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewMoreTemplatesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	whiteboardTemplateType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageTemplateType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	livePageTemplateType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	templateCardAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	modalTitle: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.title',
		defaultMessage: 'We recommend these for you',
		description: 'Title of the template recommendation modal',
	},
	modalSubtitle: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.subtitle',
		defaultMessage: 'Skip the setup and jump into a template to get started.',
		description: 'Subtitle explaining the purpose of the template modal',
	},
	startBlankDoc: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.start-blank-doc',
		defaultMessage: 'Start blank doc',
		description: 'Button label to start with a blank document',
	},
	viewMoreTemplates: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.view-more-templates',
		defaultMessage: 'View more templates',
		description:
			'The text is shown on a link inside the template touchpoint modal that takes the user to the full template gallery where they can browse all available templates.',
	},
	closeModal: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.close',
		defaultMessage: 'Close',
		description:
			'The text is shown on a button that closes the template touchpoint modal, dismissing the template recommendation dialog.',
	},
	buttonUseTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.use-template',
		defaultMessage: 'Use template',
		description: 'Button label to use the recommended template',
	},
	closeModalLabel: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.close-label',
		defaultMessage: 'Close modal',
		description:
			'The text is used as an accessible aria-label for the close button icon in the template touchpoint modal, providing screen reader users with a more descriptive label than the visible button text.',
	},
	startBlankDocLabel: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.start-blank-doc-label',
		defaultMessage: 'Start blank document',
		description:
			'The text is used as an accessible aria-label for the icon button that starts editing a blank document, shown in the template touchpoint modal as an alternative to selecting a template.',
	},
	viewMoreTemplatesLabel: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.view-more-templates-label',
		defaultMessage: 'View more templates',
		description:
			'The text is used as an accessible aria-label for the icon button that navigates to the full template gallery, shown in the template touchpoint modal alongside the view more templates link.',
	},
	whiteboardTemplateType: {
		id: 'experiment-cfind-5291-template-touchpoint.whiteboard.template',
		defaultMessage: 'Whiteboard',
		description: 'Label for whiteboard content type on template cards and in template data',
	},
	pageTemplateType: {
		id: 'experiment-cfind-5291-template-touchpoint.page.template',
		defaultMessage: 'Page',
		description: 'Label for page content type on template cards and in template data',
	},
	livePageTemplateType: {
		id: 'experiment-cfind-5291-template-touchpoint.livepage.template',
		defaultMessage: 'Doc',
		description: 'Label for live page content type on template cards and in template data',
	},
	templateCardAriaLabel: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.template-card-aria-label',
		defaultMessage: 'Use {templateName} {contentType} template',
		description:
			'Aria label for template recommendation cards, with variables for the template name and content type',
	},
});
